import React, { Fragment } from "react"
import { Route, Switch } from "react-router"
import styled from "styled-components"

import Header from "./views/Header"
import Menu from "./components/Menu"
import MenuView from "./views/SideMenu/MenuView"
import Home from "./views/Home"

const Wrapper = styled.div`
  display: flex;
  height: 56px;
  background-color: #000000cf;
`

class Campaign extends React.Component {
  render() {
    return (
      <Fragment>
        <Wrapper>
          <Menu>
            <MenuView />
          </Menu>
          <Header freeBids={true} />
        </Wrapper>
        <Switch>
          <Route path='/play/' component={Home} />
        </Switch>
      </Fragment>
    )
  }
}

export default Campaign



// WEBPACK FOOTER //
// ./src/Campaign.js